'use client';

import CpIconLogo from '@/components/app-ui/CpIconLogo';
import { useEffect, useRef, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import SignupLanding from './components/SignupLanding';
import SsoSignupForm from './components/SsoSignupForm';
import CredentialsSignupForm from './CredentialsSignupForm';
import { CheckCircle2 } from 'lucide-react';
import Image from 'next/image';
import IMAGE_CONSTANTS from '@/constants/image.constants';
import { capacitorStorageService } from '@/services/capacitor-storage.service';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { RECAPTCHA_SITE_KEY } from '@/constants/form.constants';

const bulletPoints = [
	{
		title: 'Interactive presentations',
		description: 'Transform slides into engaging experiences, captivating your audience effortlessly.',
	},
	{
		title: 'Gamify your Classroom',
		description: 'Foster real-time student participation and understanding through gamified learning.',
	},
	{
		title: 'Powered by AI',
		description: 'Elevate your presentation game with AI, seamlessly integrated into PowerPoint.',
	},
];

export default function SignupPage() {
	const router = useRouter();
	const searchParams = useSearchParams();

	const contentSlug = searchParams.get('c') || '';
	const fromAddin = searchParams.get('addin') === 'true';

	const fromRef = useRef(searchParams.get('from') || '');
	const isSso = fromRef.current === 'sso';
	const [onFormScreen, setOnFormScreen] = useState(isSso);
	const [signupEmail, setSignupEmail] = useState('');

	useEffect(() => {
		if (contentSlug || fromAddin) {
			capacitorStorageService.setSignupParams({ contentSlug, fromAddin });
		}
		router.replace('/auth/signup'); // remove from=sso so when refreshing the page, it shows the default signup page
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="flex min-h-[100dvh]">
			{/* <div className="relative hidden w-0 flex-1 lg:flex lg:items-center lg:justify-center">
				<div className="z-10 -mt-12 flex w-96 flex-col gap-8 text-white">
					{bulletPoints.map((bulletPoint, index) => {
						return (
							<div key={index}>
								<h3 className="mb-2 flex items-center gap-2 text-xl text-white">
									<CheckCircle2 />
									{bulletPoint.title}
								</h3>
								<p className="text-sm">{bulletPoint.description}</p>
							</div>
						);
					})}
				</div>
				<div className="absolute bottom-4 z-10 text-xs font-light text-white">
					&#169; INKNOE {new Date().getFullYear()}. All rights reserved.
				</div>
				<Image src={IMAGE_CONSTANTS.SIGNUP_BG} alt="Sign up ClassPoint" fill priority className="z-0" />
			</div> */}
			<div className="box-border flex flex-1 flex-col justify-center py-8">
				<div className="px-8 xxs:px-12">
					<div className="mx-auto max-w-sm">
						<div className="mx-auto w-[90%]">
							<CpIconLogo className="h-14" />
							<h2 className="text-center">{isSso ? 'Finish signing up' : 'Create your account'}</h2>
							<p className="py-2 text-center text-sm text-muted-foreground">
								The all-in-one AI-powered interactive teaching software for you and your students.
							</p>
						</div>

						<div className="mx-auto mb-4 mt-6 w-[90%] max-w-sm">
							{!onFormScreen ? (
								<SignupLanding setSignupEmail={setSignupEmail} setOnFormScreen={setOnFormScreen} />
							) : (
								// <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
								<div>
									{isSso ? <SsoSignupForm /> : <CredentialsSignupForm signupEmail={signupEmail} />}
								</div>
								// </GoogleReCaptchaProvider>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
